import { useNavigate } from 'react-router-dom';

export const useListRow = () => {
  const navigate = useNavigate();

  return { navigate };
};
